module.exports = __webpack_public_path__ + "img/share_air.a84ede8d.jpg";